(function () {
  if (customElements.get('h-before-after')) return;

  class HBeforeAfter extends HTMLElement {
    connectedCallback() {
      if (this.hInitialized) return;
      this.hInitialized = true;

      this.hCompare = this.querySelector('[data-h-compare]');
      this.hHandle = this.querySelector('[data-h-handle]');

      if (!this.hCompare || !this.hHandle) return;

      this.hDragging = false;
      this.hActivePointerId = null;
      this.hBoundOnPointerMove = this.hOnPointerMove.bind(this);
      this.hBoundOnPointerUp = this.hOnPointerUp.bind(this);
      this.hBoundOnKeyDown = this.hOnKeyDown.bind(this);
      this.hBoundOnPointerDown = this.hOnPointerDown.bind(this);

      const initial = Number(this.dataset.hInitialPosition);
      this.hSetPosition(Number.isFinite(initial) ? initial : 50, false);

      this.hCompare.addEventListener('pointerdown', this.hBoundOnPointerDown);
      this.hHandle.addEventListener('keydown', this.hBoundOnKeyDown);
    }

    disconnectedCallback() {
      this.hTeardown();
      this.hInitialized = false;
    }

    hTeardown() {
      if (this.hCompare) {
        this.hCompare.removeEventListener('pointerdown', this.hBoundOnPointerDown);
      }

      if (this.hHandle) {
        this.hHandle.removeEventListener('keydown', this.hBoundOnKeyDown);
      }

      this.hReleasePointer();
    }

    hClamp(value) {
      return Math.min(100, Math.max(0, value));
    }

    hSetPosition(value, announce) {
      const position = this.hClamp(value);
      this.style.setProperty('--h-position', `${position}%`);

      if (this.hHandle) {
        this.hHandle.setAttribute('aria-valuenow', String(Math.round(position)));
        if (announce !== false) {
          this.hHandle.setAttribute('aria-valuetext', `${Math.round(position)}%`);
        }
      }
    }

    hPositionFromClientX(clientX) {
      const rect = this.hCompare.getBoundingClientRect();
      if (!rect.width) return 0;

      const ratio = (clientX - rect.left) / rect.width;
      return this.hClamp(ratio * 100);
    }

    hOnPointerDown(event) {
      if (event.button != null && event.button !== 0) return;
      if (event.target.closest('a, button:not([data-h-handle])')) return;

      this.hDragging = true;
      this.hActivePointerId = event.pointerId;
      this.hCompare.classList.add('is-h-dragging');

      try {
        this.hCompare.setPointerCapture(event.pointerId);
      } catch (error) {
        // Pointer capture can fail on unsupported targets; drag still works via listeners.
      }

      this.hCompare.addEventListener('pointermove', this.hBoundOnPointerMove);
      this.hCompare.addEventListener('pointerup', this.hBoundOnPointerUp);
      this.hCompare.addEventListener('pointercancel', this.hBoundOnPointerUp);

      this.hSetPosition(this.hPositionFromClientX(event.clientX));
      event.preventDefault();
    }

    hOnPointerMove(event) {
      if (!this.hDragging) return;
      if (this.hActivePointerId != null && event.pointerId !== this.hActivePointerId) return;
      this.hSetPosition(this.hPositionFromClientX(event.clientX));
    }

    hOnPointerUp(event) {
      if (this.hActivePointerId != null && event.pointerId !== this.hActivePointerId) return;
      this.hReleasePointer();
    }

    hReleasePointer() {
      this.hDragging = false;
      this.hActivePointerId = null;

      if (this.hCompare) {
        this.hCompare.classList.remove('is-h-dragging');
        this.hCompare.removeEventListener('pointermove', this.hBoundOnPointerMove);
        this.hCompare.removeEventListener('pointerup', this.hBoundOnPointerUp);
        this.hCompare.removeEventListener('pointercancel', this.hBoundOnPointerUp);
      }
    }

    hOnKeyDown(event) {
      const current = Number(this.hHandle.getAttribute('aria-valuenow')) || 0;
      const step = event.shiftKey ? 10 : 1;
      let next = current;

      switch (event.key) {
        case 'ArrowLeft':
          next = current - step;
          break;
        case 'ArrowRight':
          next = current + step;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = 100;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.hSetPosition(next);
    }
  }

  customElements.define('h-before-after', HBeforeAfter);
})();
